import React from "react";
import { Stack, inputBaseClasses, chipClasses } from "@mui/material";
import Field from "@hyro-components/fields/HyroField";
import { FIELD_TYPES } from "@hyro-components/fields/utils";
import FilterFieldHeader from "../filter-field-header/FilterFieldHeader";

const FilterFieldList = ({ label, value, onChange, onClose }) => (
  <Stack gap={1} p={1.5}>
    <FilterFieldHeader label={label} />
    <Field
      fieldType={FIELD_TYPES.LIST}
      value={value || []}
      sx={{
        height: "44px",
        [`& .${inputBaseClasses.root}`]: {
          height: "44px",
          paddingBlock: "0"
        },
        [`& .${chipClasses.root}`]: {
          maxWidth: "100px"
        }
      }}
      displayTagsBelow
      showAllChips
      onChange={newValue => {
        onChange(newValue);
      }}
      open
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onClose();
        }
      }}
    />
  </Stack>
);

export default FilterFieldList;
